module.exports = __webpack_public_path__ + "static/img/jp5.d5ed5612.png";